import { PayPeriodEnum } from '@umss/shared/utils';

export interface PayPeriod {
  id: string;
  facilityId: string;
  startDate: string; // YYYY-MM-DD
  endDate: string; // YYYY-MM-DD
  nextPayDate: string; // YYYY-MM-DD
}

export interface FacilityPayPeriod {
  id: number;
  facilityId: string;
  payPeriodType: PayPeriodEnum;
  payPeriodTypeDisplay: string;
  startDate: string; // DateOnly ISO string
  endDate: string | null; // DateOnly ISO string or null (null = active)
  nextPayDate: string; // DateOnly ISO string
  firstPaymentDay: number | null; // day of week (1-7) or day of month (1-31)
  secondPaymentDay: number | null; // only for TwiceMonthly
  anchorDate: string | null; // DateOnly ISO string or null
  customPayDates: string[] | null; // DateOnly ISO strings or null
}

export interface UpdateFacilityPayPeriod {
  payPeriodType: PayPeriodEnum; // required
  firstPaymentDay: number; // required, min: 1, max: 31
  secondPaymentDay?: number; // optional, min: 1, max: 31 (required for TwiceMonthly)
  anchorDate?: string; // optional, DateOnly ISO (required for Biweekly)
  customPayDates?: string[]; // optional, DateOnly ISO strings (required for Custom)
}
